<template>
  <div class="page_effExportList">
    <div class="topOperation">
      <div class="top-left">
        <div class="flex">
          <ShowNavHead />
          <!-- <div class="flex">
            <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="110px">
              <el-form-item label="报表名称" size="small">
                <el-input v-model="listQuery.excelname" size="small" placeholder="" clearable style="width: 180px;"></el-input>
              </el-form-item>
            </el-form>
          </div> -->
        </div>
      </div>
      <div class="top-right">
         <!-- <el-button v-preventReClick type="success" size="small" @click="getExportRecord" style="margin-right: 15px;">搜索</el-button> -->
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>报表</el-breadcrumb-item>
          <el-breadcrumb-item>运营报表</el-breadcrumb-item>
          <el-breadcrumb-item>导出记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="expRecordTable">
        <div class="ftabs">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="月招聘来源总报表（按项目）" name="JBreportKFpro">
            </el-tab-pane>
            <el-tab-pane label="年度入离职数据统计表" name="JBreportKFyear">
            </el-tab-pane>
            <el-tab-pane label="月+周度入离职数据统计表" name="JBreportKF">
            </el-tab-pane>
            <el-tab-pane label="入离职人员明细统计" name="JBreportKFemp">
            </el-tab-pane>
            <el-tab-pane label="导出记录" name="expRecond">
            </el-tab-pane>
          </el-tabs>
        </div>
        <el-table :data="tableData" class="doc_table" border :max-height="tableHeight-180" style="width: 100%" v-loading="listLoading" element-loading-text="导出记录生成中" element-loading-spinner="el-icon-loading">
          <!-- <el-table-column align="center" type="selection" width="50"></el-table-column> -->
          <el-table-column align="center" label="序号" type="index" width="80"></el-table-column>
          <!-- <el-table-column align="center" label="服务中心" prop="StrServCentName" min-width="12%"></el-table-column> -->
          <!-- <el-table-column align="center" label="报表名称" prop="StrOutCustName" min-width="16%"></el-table-column> -->
          <el-table-column align="center" label="报表名称" prop="StrOutCustName" min-width="200px" fit :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column align="center" label="业务立项部门" prop="StrImpInstName" min-width="15%"></el-table-column> -->
          <!-- <el-table-column align="center" label="负责客服" prop="StrServUsrName" min-width="15%"></el-table-column> -->
          <el-table-column align="center" label="格式" prop="DtImpDate" min-width="85px">
            <template>xls</template>
          </el-table-column>
          <el-table-column align="center" label="操作人员" prop="Username" width="120px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" label="操作时间" min-width="160px">
            <template slot-scope="{row}">
              <span>{{row.DtImpDate.replace('T','  ')}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态" prop="DtImpDate" min-width="120px">
            <template slot-scope="scope">
              <!-- {{(scope.row.StrOutPath) ? "已生成" : "正在生成中"}} -->
              <span v-show="scope.row.StrOutPath">已生成</span>
              <span v-show="!scope.row.StrOutPath&&(new Date().getTime() < new Date((new Date(scope.row.DtImpDate)).valueOf() + 360000).getTime())">
                <i class="el-icon-loading"></i>
                <span>正在生成中</span>
              </span>
              <span v-show="!scope.row.StrOutPath&&(new Date().getTime() > new Date((new Date(scope.row.DtImpDate)).valueOf() + 360000).getTime())">
                <span>导出失败</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" prop="StrOperType" min-width="100px">
            <template slot-scope="scope">
              <a :href="tablePath + scope.row.StrOutPath" v-if="scope.row.StrOutPath">下载</a>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalnum>0">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="10" layout="total,prev, pager, next, jumper" :total="totalnum"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    name: "HelloWorld",
    data() {
      return {
        activeName: 'expRecond',
        tablePath: this.$store.state.EMP.tablePath,
        tableHeight: 0,
        listLoading: false,
        tableData: [],
        currentPage: 1,
        totalnum: 1,
        //下拉筛选
        showDropScreen: -1,
        //时间范围
        impdate: [],
        listQuery: {
          pagecount: 10,
          currpage: 1,
          excelname: "",
          tableid: "JBreportKFpro,JBreportKFyear,JBreportKF,JBreportKFemp",
          instname: "",
          impdatestart: "",
          impdateend: "",
          objname: "",
          strobjinstname: "",
          strusername: "",
          impdate: "",
          custname: "",
          reload: false
        },
        //定时器
        interval: null,
        type: '',
        permissionLists: []
      };
    },
    async created() {
      this.calHeight();
      this.getButtonPower();
      this.getExportRecord(this.infoQuery)
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {

      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        console.log('height', this.tableHeight)
      },
      //翻页
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currpage = `${val}`;
        this.infoQuery.currpage = val
        this.getExportRecord(this.infoQuery)
      },
      //搜索
      searchKeyWord() {
        this.infoQuery.currpage = 1
        this.getExportRecord(this.infoQuery)
      },
      //导出记录历史
      getExportRecord(data) {
        this.loading = true;
        xz.getReportOutList(this.listQuery, 'getReportOutList').then(res => {
          if (res.status == 'ok') {
            this.tableData = res.msg;
            this.totalnum = res.totalcount;
          }
        })
      },
      handleClick(tab) {
        if (tab.name == 'expRecond') {
          return
        } else {
          this.$router.push({
            path: '/report',
            query: {
              activeName: tab.name
            }
          })
        }
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      beforeDestroy() {
        // 在页面销毁后，清除计时器
        clearInterval(this.interval);
        this.interval = null
      }
    }

  };
</script>



<style>
  .operationRecordTable .el-table td {
    padding: 5px 0;
  }

  .operationRecordTable .el-table th {
    padding: 10px 0;
  }

  .screenInput .el-input {
    width: 70%;
    margin-left: 5px;
  }

  .formScreenInput .el-input__inner {
    height: 32px;
    line-height: 32px;
    width: 180px;
    margin-top: 10px;
  }

  .formScreenInput .el-input__icon {
    margin-top: 10px;
    height: 32px;
    line-height: 32px;
  }

  .page_effExportList .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_effExportList .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }
</style>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
  }
</style>